import styles from './ExtraCheckInModal.module.scss';
import { values } from '../CheckIn/checkInValues';
import { MiddleSchoolCheckInEntry } from '@peekapak/types/ReportDataExchangeTypes';

interface Props {
  hideModal: () => void;
  checkIns: MiddleSchoolCheckInEntry[];
  date: Date;
}

const ExtraCheckInModal = ({ hideModal, checkIns, date }: Props): JSX.Element => {
  const getTextColor = (feeling: string) => {
    if (feeling === undefined) return '#86939e';
    if (values.findIndex((value) => value.subEmotions.includes(feeling)) < 2) return '#43484d';
    return '#fff';
  };

  const formattedDate = date.toLocaleDateString('en-US', {
    month: 'long',
    day: 'numeric',
  });

  // Sort check-ins by time ascending (earliest first)
  const sortedCheckIns = [...checkIns].sort((a, b) => a.createdAt - b.createdAt);

  return (
    <div className={styles.container}>
      <div className={styles.title}>
        <h2 className={styles.name}>Check-Ins - {formattedDate}</h2>
        <button onClick={hideModal} aria-label='Close modal'>
          ×
        </button>
      </div>
      <div className={styles.studentDataContainer}>
        {sortedCheckIns.map((checkIn, index) => {
          const emotionColor =
            values.find((value) => value.subEmotions.includes(checkIn.feeling))?.segmentColor || '#bbc2ca';
          const time = new Date(checkIn.createdAt).toLocaleTimeString('en-US', {
            hour: '2-digit',
            minute: '2-digit',
          });
          const reasons = checkIn.reasons
            ? checkIn.reasons
                .split(',')
                .map((r) => r.trim())
                .filter(Boolean)
            : [];

          return (
            <div className={styles.emotion} key={`${checkIn.feeling}-${index}`}>
              <div className={styles.dataCell} style={{ backgroundColor: emotionColor }}>
                <h4 style={{ color: getTextColor(checkIn.feeling) }}>{checkIn.feeling?.replace('/', ' / ') || '-'}</h4>
              </div>
              <p className={styles.timeText}>{time}</p>
              {reasons.length > 0 && (
                <div className={styles.sources}>
                  <p className={styles.sourcesLabel}>Source:</p>
                  <ul className={styles.sourcesList}>
                    {reasons.map((reason, i) => (
                      <li key={i}>{reason}</li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ExtraCheckInModal;
